import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { BulkGrantRegisterResponse } from '@/repositories/generated';

const response: BulkGrantRegisterResponse = { id: '1' };

export const bulkGrantRegister = http.post(
  createMockEndpoint('/bulk_grant'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
